import Container from '@/components/templates/container'
import { urlForImage } from '@/sanity/lib/image'
import { useMediaQuery } from '@mui/material'
import Image from 'next/image'

const Banner = ({ imageDesktop, imageMobile }) => {
  const isMobile = useMediaQuery('(max-width:767px)')

  return (
    <Container
      outerClassName="py-largeMobile lg:py-largeDesktop"
      className="relative aspect-[3/4] md:aspect-video"
    >
      {!isMobile && (
        <Image
          src={urlForImage(imageDesktop).url()}
          alt={imageDesktop.alt}
          fill
          placeholder="blur"
          blurDataURL={imageDesktop.metadata.lqip}
          className="object-cover"
        />
      )}
      {isMobile && (
        <Image
          src={urlForImage(imageMobile).url()}
          alt={imageMobile.alt}
          fill
          placeholder="blur"
          blurDataURL={imageMobile.metadata.lqip}
          className="object-cover"
        />
      )}
    </Container>
  )
}

export default Banner
